import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { AvailableSlotApiResponse } from "./type.ts";

type useAvailableSlotsParams = {
  date?: string | null;
  hallId?: string | null;
};

const useAvailableSlots = (params: useAvailableSlotsParams) => {
  const { date, hallId } = params;

  const fetch = useFetch();

  const { data, isFetching, isError, error } = useQuery<
    AvailableSlotApiResponse | null,
    Error,
    AvailableSlotApiResponse
  >({
    queryKey: ["available-slots", date],
    enabled: !!(date && hallId),
    queryFn: () =>
      fetch<AvailableSlotApiResponse>(`${Urls.AvailableSlots}?date=${date}`, {
        method: "GET",
        slug: {
          hallId,
        },
      }),
    gcTime: 0,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message|| "Error getting booking");
    }
  }, [error?.message, isError]);

  return {
    slots: data?.availableSlots || [],
    isFetching,
  };
};

export default useAvailableSlots;
